if($('.type-detail').length){
    if ($('.p-add-to-cart-wrapper').text().trim() === '') {
        if($('html[lang="en"]').length){
            $('.p-add-to-cart-wrapper').text('Login to see your purchase prices.');
        }
        if($('html[lang="sk"]').length){
            $('.p-add-to-cart-wrapper').text("Connectez-vous pour voir vos prix d'achats.");
        }
       
    }
}